<script setup lang="ts">
import FileThumbnail from 'frontend/common/files/components/file-thumbnail.vue'
import FilesPreviewModal from 'frontend/common/files/components/files-preview-modal.vue'
import type { IFileResponseEntity } from 'frontend/common/files/types/i-file-response-entity'
import AssistiveChip from 'frontend/ui/components/assistive-chip.vue'
import { computed, ref } from 'vue'

interface Props {
  files: IFileResponseEntity[]
  modalTitle?: string
  eid: string | number
}
const props = defineProps<Props>()

const currentFileUniqueId = ref(null)

function onImageClick(file: IFileResponseEntity) {
  currentFileUniqueId.value = file.uniqueId
}

const visibleFiles = computed(() => {
  const sortedFiles = [...props.files].sort((a, b) => {
    if (a.isPrimary) {
      return -1
    }
    if (b.isPrimary) {
      return 1
    }
    return 0
  })
  return sortedFiles.length > 12 ? sortedFiles.slice(0, 11) : sortedFiles
})
</script>

<template lang="pug">
files-preview-modal(
  v-if="currentFileUniqueId"
  :files="files"
  v-model:current-file-unique-id="currentFileUniqueId"
)
  template(#header)
    .d-flex.align-items-center.gap-4
      span {{ modalTitle || 'Location Images' }}
      assistive-chip(v-if="eid")
        | EID {{ `#${eid}` }}

.table-file-thumbnails(v-if="props.files.length")
  file-thumbnail(
    v-for="file in visibleFiles"
    :file="file"
    :image-tooltip="file.category"
    :key="file.uniqueId"
    :preferred-variant-size="[24, 24]"
    @image-click="onImageClick(file)"
    hide-delete-icon
  )
  .more-files-indicator(v-if="visibleFiles.length < props.files.length") +{{ props.files.length - visibleFiles.length }}
.text-nowrap.text-black-15(v-else) empty
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.table-file-thumbnails {
  display: grid;
  // min max
  grid-template-columns: repeat(auto-fill, minmax(24px, 1fr));
  gap: 4px;
}

.more-files-indicator {
  background: map.get(themeVariables.$colors, secondaryContainer);
  color: map.get(themeVariables.$colors, onSecondaryContainer);
  border-radius: themeVariables.$borderRadius;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
